const perf_data = require('./perf-charts-data');
const constants = require('../../shared/constants');
const constantsShared = require('../../shared/constants');

module.exports = function (data) {

  // TODO
  if(!data) {
    data = [];
    $.each(perf_data[0], function(key, value) {
      data[key]=value;
    });
  }

  const options = {
    colors: constants.COLORS.RISKS,
    chart: {
      type: 'column',
      style: {
        fontSize: '1em'
      }
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    xAxis: {
      categories: data.name,
      labels: {
        style: {'fontSize': '1em'},
        autoRotation: false
      },
      tickLength: 0
    },
    yAxis: {
      min: 0,
      title: {
        text: null
      },
      labels: {
        enabled: false
      }
    },
    tooltip: {
      headerFormat: '',
      formatter: function() {
        const color = this.point.color.stops[1][1];
        return '<div style="text-align:center;">Volatilité<br/><span style="color:'+color+'">'+data.vol[this.series.data.indexOf( this.point )]+'%</span></div>';
      },
      style: {
        fontFamily: constantsShared.FONT_CHARTS.fontFamily,
        fontSize: '1em',
        fontWeight: 600,
        zIndex: 10
      },
      useHTML: true,
      positioner:function(label_width, label_height, point){
        const x = point.plotX - label_width/2 + this.chart.plotLeft;
        const y = point.plotY - label_height - 30;
        return { x: x, y: y };
      }
    },
    series: [{
      colorByPoint: true,
      data: data.perf
    }],
    legend: {
      enabled: false
    },
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true,
          crop: false,
          overflow: 'none',
          formatter: function () {
            return '<span style="color:'+this.point.color.stops[1][1]+'; font-family: \''+constantsShared.FONT_CHARTS.fontFamily+'\'">'+this.y+'%</span>';
          },
          style: {
            fontSize: '1em'
          }
        },
        groupPadding: 0.04,
        borderWidth: 0,
        pointPadding: 0.15
      }
    }
  }

  const self = {
    chart: '',
    $el: $('#chart-perf'),
    options: options
  }

  self.$el.highcharts(self.options)

  return {
    reload: function(){
      self.$el.highcharts().destroy()
      self.$el.highcharts(self.options)
    }
  }
}
